module.exports = __webpack_public_path__ + "static/media/ost_16.8c883e36.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/ost_16.png
// module id = 1041
// module chunks = 0